import React from 'react';
import { Modal, Button, ModalCloseReason } from '@economic/gaudi';

import { InvoicingMessage } from '../../../../../../types/internal-api';
import { t } from '../../../../../shared/components/l10n/l10n';
import Icon from '../../../../../shared/components/ui/primitives/Icon';

interface SalesErrorProps {
    title?: string;
    errorMessages: InvoicingMessage[];
    onOk?: () => void;
}

function SalesError({ title, errorMessages, onOk }: SalesErrorProps) {
    return (
        <>
            <Modal.Header>
                <Icon
                    name="warning"
                    className="book-and-send-dialog__exclamation-badge"
                    aria-label={title || t`FORM_BOOKANDSEND_ERRORS_HEADER`}
                    badge="error"
                />
            </Modal.Header>
            <Modal.Content>
                <p className="book-and-send-dialog__sub-header">{title || t`FORM_BOOKANDSEND_ERRORS_HEADER`}</p>
                {errorMessages && errorMessages.map((error, index) => <p key={index}>{error.message}</p>)}
            </Modal.Content>
            <Modal.Footer>
                <Button appearance="primary" onClick={onOk}>{t`SHARED_FORM_OK`}</Button>
            </Modal.Footer>
        </>
    );
}

interface SalesErrorModalProps {
    title?: string;
    errors: InvoicingMessage[];
    disclosure: React.ReactElement<React.HTMLAttributes<HTMLElement>>;
    onHide: (reason: ModalCloseReason) => void;
}

export function SalesErrorDialog(props: SalesErrorModalProps) {
    const { title, errors, disclosure, onHide } = props;

    return (
        <Modal
            aria-label={title || t`FORM_BOOKANDSEND_ERRORS_HEADER`}
            className="book-and-send-error-dialog"
            size="xs"
            disclosure={disclosure}
            onHide={onHide}>
            {({ hide }) => <SalesError title={title} errorMessages={[...errors]} onOk={hide} />}
        </Modal>
    );
}
